import styled from 'styled-components';
import React, { FC, ReactNode } from 'react';

interface PageProps {
  header?: ReactNode;
  /**
   * For further composition via styled-components.
   * See https://github.com/styled-components/styled-components/issues/265
   */
  className?: string;
  topContent?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
}

export const Page: FC<PageProps> = ({
  children: main,
  className,
  header,
  footer,
  topContent = null,
}) => (
  <PageWrapper className={className}>
    {topContent && <Section>{topContent}</Section>}
    <Section>
      {Boolean(header) && <Header>{header}</Header>}
      <Main>{main}</Main>
      {Boolean(footer) && <Footer>{footer}</Footer>}
    </Section>
  </PageWrapper>
);

const PageWrapper = styled.div`
  padding: 25px 25px 25px 35px;
  min-height: 100%;
  background-color: #f5f5f8;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
`;

const Section = styled.section``;

const Main = styled.main``;

const Footer = styled.footer``;
